<!-- Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
.answerItem {
  width: 80%;
  height: 4rem;
  padding: 1.125rem 1.875rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  color: #7e7885;
  margin-bottom: 1.25rem;
  word-break: break-word;
  overflow: hidden;
}

.answerItem.disabled {
  background-color: #bfbfbf;
}

@media (hover: hover) {
  .answerItem:hover {
    background-color: #e4e1e8;
  }
}

@media (hover: none) {
  .answerItem:active {
    background-color: #7e7885;
  }
}

.answersWrapper {
  margin: 1.875rem 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.answersDetailsWrapper {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 0 6.25rem;
  box-sizing: border-box;
}

.answersItemsWrapper {
  width: 80%;
  padding: 0 2.25rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.answersDetailsWrapper > div {
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.answerDetail {
  display: inline-block;
}

.template7wrapper h2 {
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  color: #333333;
  text-transform: none;
}

.template7wrapper h3 {
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  color: #7e7885;
  padding: 0.5625rem 0 0 0;
  text-transform: none;
}
.subtitle {
  font-size: 1.125rem;
  font-weight: 500;
  text-align: center;
  color: #7e7885;
  margin-bottom: 0.875rem;
  width: 24rem;
}

.fade-leave,
.fade-leave-active {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

@media (max-width: 576px) {
  .answersWrapper {
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
  }
  .answersItemsWrapper {
    width: 100%;
    padding: 0rem;
  }
  .answerItem {
    width: 100%;
  }
  .subtitle {
    font-size: 0.7rem;
  }
}

</style>

<template>
    <div class="template7wrapper">
        <h2>{{ question.title }}</h2>
        <h3>{{ question.subTitle }}</h3>

        <div class="answersWrapper">
            <div class="answersItemsWrapper">
                <div
                    v-for="answer in this.answers"
                    :key="answer.id"
                    class="answerItem"
                    v-bind:class="[
                        answer.selected ? 'selected' : '',
                        answer.disabled ? 'disabled' : '',
                    ]"
                    :title="answer.text"
                    v-on:touchend.prevent="event => {selectAnswer(answer.id);mouseOver(answer.id)}"
                    v-on:click="selectAnswer(answer.id)"
                    v-on:mouseenter="mouseOver(answer.id)"
                    v-on:mouseleave="mouseOut(answer.id, $event)"
                >
                    {{ answer.title }}
                </div>
            </div>
            <div class="answersDetailsWrapper">
                <transition-group
                    name="fade"
                    tag="div"
                >
                    <div
                        v-for="answer in this.answers"
                        v-show="answer.hovered"
                        :key="answer.id"
                        class="answerDetail"
                    >
                        <p class="subtitle">
                            {{ answer.subTitle }}
                        </p>
                    </div>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Q7Template',
    computed: {
        question: function () {
            return this.$store.state.questionData;
        },
        answers: function () {
            return this.$store.state.questionData.answers;
        }
    },
    methods: {
        selectAnswer: function (aid) {
            this.$store.commit('setAnswer', aid);
        },
        mouseOver: function (aid) {
            this.$store.commit('setHover', [{ aid: aid, hover: true }]);
        },
        mouseOut: function (aid) {
            this.$store.commit('setHover', [{ aid: aid, hover: false }]);
        }
    }
};
</script>
